import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/confirm_btn.webp'
import _imports_1 from '@/assets/imgs/confirm_btn.png'
import _imports_2 from '@/assets/imgs/cancel_btn.webp'
import _imports_3 from '@/assets/imgs/cancel_btn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-d1e30152")

_pushScopeId("data-v-d1e30152")
const _hoisted_1 = _imports_0
const _hoisted_2 = _imports_2
const _hoisted_3 = { class: "label-coin-wrap" }
const _hoisted_4 = { class: "coin" }
const _hoisted_5 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_1
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/confirm_btn.png",
  draggable: "false",
  ondragstart: "return false;"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_2
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/cancel_btn.png",
  draggable: "false",
  ondragstart: "return false;"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_app_svg = _resolveComponent("app-svg")

  return (_openBlock(), _createBlock("div", {
    class: ["multi-bet-area-root", _ctx.multicolor]
  }, [
    _createVNode("div", {
      class: "highlight",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBetClicked && _ctx.handleBetClicked(...args)))
    }),
    _createVNode("div", _hoisted_3, [
      _createVNode("span", {
        class: ["label", { 'is-gray-mode': _ctx.isGrayMode }]
      }, _toDisplayString(_ctx.betLabel), 3),
      (_ctx.needToDisPlayAmount)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["bet-coin", {
                    offset: _ctx.offSet !== -1,
                    'no-bet': _ctx.hasNoBet,
                    'has-confirmed-bet': _ctx.hasBetConfirmedBet,
                    'has-unconfirm-bet': _ctx.hasUnConfirmedBet
                }]
          }, [
            _createVNode(_component_app_svg, {
              box: '0 0 67 57',
              id: 'chip',
              className: 'chip-svg',
              fill: 'rgb(221, 194, 140)',
              stroke: 'rgb(221, 194, 140)'
            }, null, 8, ["fill", "stroke"]),
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.amount), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.hasUnConfirmedBet && _ctx.betType === _ctx.currentIndex)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["cancel_confirm", { 'is-off-set': _ctx.offSet === 1 }]
        }, [
          _createVNode("picture", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.confirmBet()), ["stop"]))
          }, [
            _hoisted_5,
            _hoisted_6
          ]),
          _createVNode("picture", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelBet && _ctx.cancelBet(...args)), ["stop"]))
          }, [
            _hoisted_7,
            _hoisted_8
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
})